import { useContext, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './Vacancies.module.scss';
import MobileContext from '../../context/mobile';
import StatesContext from '../../context/states';
import CoverVacancies from '../../components/CoverVacancies';
import Articles from '../../components/Articles';
import Search from '../../components/Search';
import VacancyList from '../../components/VacancyList';
import FilterWithVacancies from '../../components/FilterWithVacancies';
import Tabs from '../../components/Tabs';
import InternshipCta from '../../components/InternshipCta';

const TABS = [
  { label: 'Вакансии', value: 'vacancies' },
  { label: 'Стажировки', value: 'internships' },
];

const Vacancies = () => {
  const states = useContext(StatesContext);
  const isMobile = useContext(MobileContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const isValidTab = TABS.some((tab) => tab.value === searchParams.get('tab'));
  const [activeTab, setActiveTab] = useState(
    isValidTab ? searchParams.get('tab') : 'vacancies'
  );

  const handleTabChange = (value) => {
    setActiveTab(value);
    const params = new URLSearchParams(searchParams);
    if (value === 'vacancies') {
      params.delete('tab');
    } else {
      params.set('tab', value);
    }
    setSearchParams(params, { replace: true });
  };

  const refArticle = useRef(null);
  const refCover = useRef(null);
  const refStickyContainer = useRef(null);

  const { dataFilter, vacancyLength, dataArticles, dataVacancy, dataInternship } =
    states;

  const isInternships = activeTab === 'internships';

  const scrollToArticles = () => {
    if (refArticle.current !== null) {
      refArticle.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    if (window.location.hash !== '' && window.location.hash === '#list') {
      const cover = refCover.current;
      window.scrollTo(0, cover.offsetHeight + 5);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (refArticle.current === null) return;
    const article = refArticle.current;
    const stickyContainer = refStickyContainer.current;
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyContainer.style.opacity = 0;
          stickyContainer.style.pointerEvents = 'none';
        } else {
          stickyContainer.style.opacity = '';
          stickyContainer.style.pointerEvents = '';
        }
      });
    }, options);
    if (isMobile) {
      observer.observe(article);
    } else {
      observer.unobserve(article);
    }
    return () => {
      stickyContainer.style.opacity = '';
      stickyContainer.style.pointerEvents = '';
      observer.unobserve(article);
    };
  }, [dataFilter, isMobile, vacancyLength]);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover} ref={refCover} data-header-trigger={true}>
          <CoverVacancies />
        </div>

        <section className={styles.main}>
          {dataArticles !== null && dataArticles.length > 0 && (
            <div className={styles.sticky}>
              <div
                className={styles.sticky__container}
                ref={refStickyContainer}
              >
                {isMobile ? (
                  <div
                    className={styles.article__btn}
                    onClick={scrollToArticles}
                  >
                    <span>Читайте статьи о нас</span>
                    <svg
                      width="10"
                      height="20"
                      viewBox="0 0 10 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 19.3945L8.7825 10.197L1 0.99953"
                        stroke="#003333"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="container">
                    <div className={styles.article} ref={refArticle}>
                      <Articles />
                    </div>{' '}
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="container">
            <Tabs
              className={styles.tabs}
              tabs={TABS}
              value={activeTab}
              onChange={handleTabChange}
            />
            <div
              className={`${styles.grid} ${
                isInternships ? styles.grid_internships : ''
              }`}
            >
              <div className={styles.col}>
                <div className={styles.search}>
                  <Search isInternship={isInternships} />
                  <FilterWithVacancies />
                </div>
                <div className={styles.list}>
                  <VacancyList
                    data={isInternships ? dataInternship : dataVacancy}
                    isInternship={isInternships}
                  />
                </div>
              </div>
            </div>
            {isInternships && (
              <InternshipCta className={styles.internshipCta} />
            )}
          </div>
        </section>

        {isMobile && dataArticles !== null && dataArticles.length > 0 && (
          <div className={styles.article} ref={refArticle}>
            <Articles />
          </div>
        )}
      </div>
    </>
  );
};

export default Vacancies;
